export default __webpack_public_path__ + "static/media/home-yoga-meditation-journey-bg.01166204.jpg";